import React from 'react'
import { Modal } from 'react-bootstrap'
import { XLg } from 'react-bootstrap-icons'
import CustomButton from './CustomButton'

const CustomModal = ({ children, show, onHide, modalTitle, size = "md" }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            backdrop="static"
            keyboard={true}
            size={size}
        >
            <Modal.Header className='justify-content-between'>
                <Modal.Title>{modalTitle}</Modal.Title>
                <CustomButton className="ps-3 pe-3" onClick={onHide}>
                    <XLg />
                </CustomButton>
            </Modal.Header>
            <Modal.Body>
                {children}
            </Modal.Body>
        </Modal>
    )
}

export default CustomModal